import helper from './multi-account-helper.js'

const initialState = {
  ...helper.createInitialState(),
  defaultAccountStates: {},
}

export default initialState
